export default {
    brush: {
        title: 'Borstel',
        brushHardness: 'Penseelhardheid',
        brushSize: 'Penseelgrootte',
        brushColor: 'Penseelkleur',
    },
};
